import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpinnerResultComponent } from './spinner-result.component';

@NgModule({
  declarations: [SpinnerResultComponent],
  imports: [CommonModule],
  exports: [SpinnerResultComponent],
})
export class SpinnerResultModule {}
